export default {"src":"/_next/static/media/InfectiousDiseases.9ea742f2.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};